import "./style.scss"

function Icon({
  children,
  bordered = false,
  onClick,
  iconColor,
  disabled = false,
}: $TSMigrationFixMe) {
  return bordered ? (
    <div
      className={`icon-bordered__container ${disabled ? "tw-opacity-30" : ""}`}
      onClick={onClick}
    >
      <span
        className='tab icon'
        style={{ color: iconColor }}
      >
        {children}
      </span>
    </div>
  ) : (
    <div
      className=''
      onClick={onClick}
    >
      <span
        className='tab icon'
        onClick={onClick}
        style={{ color: iconColor }}
      >
        {children}
      </span>
    </div>
  )
}

export default Icon
